import styled from 'styled-components';
import { minWidth } from 'helpers/buildMediaQueries';
import {
  gutterVariables,
  Heading,
  HeadingProps,
  colorsVariables,
  boxShadowsVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';

export const Aside = styled.aside`
  grid-area: 3 / 2 / 4 / 2;
  padding: ${gutterVariables.GUTTER} 0;
  display: none;
  background-color: ${colorsVariables.WHITE};
  border-radius: 10px;
  box-shadow: ${boxShadowsVariables.searchField};
  ${minWidth(
    'xl',
    `display: block; grid-area: 2 / 2 / 4 / 2; margin-top: 10px; padding: ${gutterVariables.GUTTER_PLUS_HALF} 0;`
  )};
`;

export const AsideHeading = styled(Heading)<HeadingProps>`
  margin-bottom: ${gutterVariables.GUTTER};
  line-height: 1.5;
  padding: 0 24px;
  font-weight: 600;
`;
